export function removeItemArrayUtil (arr, value) {
  return arr.filter((val) => {
    return value !== val
  })
}
